import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const METANI_PORTAL = 'https://metani.itaninetworkchain.com';

const DEFAULT_APP_REDIRECTS = {
  artlinks: 'https://www.itartlinks.com/',
  itartlinks: 'https://www.itartlinks.com/',
  hudlife: 'https://hudlife.itaninetworkchain.com/',
  hudworld: 'https://hudworld.itaninetworkchain.com/',
  huddy: 'https://huddy.itaninetworkchain.com/',
  myelbox: 'https://www.myelbox.uk/',
  inc_wallet: 'https://app.itaninetworkchain.com/',
  wallet: 'https://app.itaninetworkchain.com/',
  itani_kobs: 'https://app.itaninetworkchain.com/',
  hudlife_dex: 'https://swap.itaninetworkchain.com/',
  swap: 'https://swap.itaninetworkchain.com/',
};

function normalize(value) {
  return String(value || '').trim();
}

export default function LocalSSO(props) {
  const [searchParams] = useSearchParams();
  const targetApp = normalize(searchParams.get('app')) || 'hudlife';
  const explicitRedirect = normalize(
    searchParams.get('redirect_uri') ||
      searchParams.get('redirect') ||
      searchParams.get('return_to') ||
      searchParams.get('callback')
  );
  const redirectUri = explicitRedirect || DEFAULT_APP_REDIRECTS[targetApp.toLowerCase()] || window.location.origin;
  const mode = normalize(props?.initialMode) === 'register' ? 'register' : 'login';

  useEffect(() => {
    const url = new URL(`${METANI_PORTAL}/${mode === 'register' ? 'register' : 'login'}`);
    url.searchParams.set('app', targetApp);
    url.searchParams.set('client_id', 'hudlife-web');
    url.searchParams.set('redirect_uri', redirectUri);
    url.searchParams.set('mode', mode);
    url.searchParams.set('provider', 'metani');
    window.location.replace(url.toString());
  }, [mode, redirectUri, targetApp]);

  return (
    <main className="min-h-screen bg-slate-950 p-8 text-white">
      <h1 className="text-2xl font-semibold">Redirection vers Metani ID</h1>
      <p className="mt-3 text-slate-300">HudLife utilise maintenant le compte central Metani pour la connexion et la creation de compte.</p>
    </main>
  );
}
